import { makeStyles, Theme } from "@material-ui/core";
import { appBarConstants, navBarConstants } from "../../AppStyles";

type menuItemBadgeStyleProps = { bgColor: string; textColor: string };
export const useMenuItemBadgeStyles = makeStyles((theme: Theme) => ({
	badge: {
		backgroundColor: (props: menuItemBadgeStyleProps) => props.bgColor,
		color: (props: menuItemBadgeStyleProps) => props.textColor,
	},
	badgeOnExpanded: {
		right: "unset !important",
	},
}));

export const useMenuStyles = makeStyles((theme: Theme) => ({
	drawer: {
		width: navBarConstants.drawerWidth,
		flexShrink: 0,
		marginTop: appBarConstants.height,
	},
	drawerOpen: {
		background: navBarConstants.backgroundColor,
		width: navBarConstants.drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerClose: {
		background: navBarConstants.backgroundColor,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		overflowX: "hidden",
		width: "85px",
	},
	drawerContainer: {
		overflow: "hidden",
		height: "100%",
	},
	list: {
		padding: 0,
		height: "100%",
	},
	selectedMenuItem: {
		background: `linear-gradient(90deg, rgba(255,0,0,1) 3%, ${navBarConstants.backgroundColor} 3%, ${navBarConstants.backgroundColor} 100%);`,
		border: 0,
		"&:hover": {
			backgroundColor: "white",
		},
		height: "50px",
	},
	menuItem: {
		color: theme.palette.primary.light,
		border: 0,
		height: "50px",
	},
	selectedIcon: {
		color: theme.palette.primary.light,
		marginRight: "10px",
		marginLeft: "10px",
	},
	icon: {
		color: theme.palette.primary.light,
		marginRight: "10px",
		marginLeft: "10px",
	},
	menuItemIconCollapsed: {
		flexShrink: "unset",
	},
	menuItemCollapsed: {
		height: "85px",
		fontSize: "0.750rem",
		fontWeight: "bold",
		textAlign: "center",
	},
	menuItemTextCollapsed: {
		wordWrap: "break-word",
		maxWidth: "60px",
		color: theme.palette.primary.light,
	},
	selectedText: {
		color: theme.palette.primary.light,
	},
	text: {
		color: theme.palette.primary.light,
	},
}));
